import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import UiContent from "../../Components/Common/UiContent";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import TrainingVideoCard from "./TrainingVideoCard";
import Loader from "../../Components/Common/Loader";
import { useHistory } from "react-router-dom";
import CustomPagination from "../../Components/Common/CustomPagination";
import { useSelector } from "react-redux";

const TrainingVideos = () => {
  const history = useHistory();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [selectedPage, setSelectedPage] = useState(0);
  const [currency, setCurrency] = useState('$');
  const { currentOutlet } = useSelector((state) => ({
        currentOutlet: state.UserOutletGroup.currentOutlet
  }));
  useEffect(() => {
      if (currentOutlet?.currency !== "") {
        setCurrency(currentOutlet?.currency);
      }
  }, [currentOutlet]);

  useEffect(() => {
    fetchVideos();
  }, [selectedPage]);

  const fetchVideos = () => {
    setLoading(true);

    postDataAPI({
      serviceName: "traning_video_data",
      op: "get-training-videos",
      load: selectedPage+1,
      is_show_all: true
    })
      .then((res) => {
        console.log(res);
        
        if (res.status === "ok") {
          setVideos(res.data.video_data || []);
          setPageCount(Math.ceil(parseInt(res.data.total_records) / 9));
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          {loading && <Loader />}

          <BreadCrumb
            title="Training Videos"
            pageTitle="Dashboard"
          />

          {/* Header */}
          <Row className="align-items-center mb-4">
            <Col className="text-end">
              <Button
                outline
                onClick={() => history.push("/server-performance-coaching")}
              >
                ⬅ Back to Home
              </Button>
            </Col>
          </Row>

          {/* Video Cards */}
          <Row className="g-4">
            {videos.map((video) => (
              <Col key={video.flash_card_id} sm="6" md="4" lg="4">
                <TrainingVideoCard video={video} currency={currency} onRefresh={fetchVideos} />
              </Col>
            ))}
            <CustomPagination
                pageCount={pageCount}
                setSelectedPage={setSelectedPage}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TrainingVideos;
